import { Edit } from "@mui/icons-material";
import { Avatar, Button, Paper, Stack, Typography } from "@mui/material";
import Admin from "api/Admin";
import Input from "components/Input";
import useForm from "js/hooks/useForm";

const schema = [
    {
        label: "First Name",
        name: "firstname",
        placeholder: "Enter first name",
        error: { required: true }
    },
    {
        label: "Last Name",
        name: "lastname",
        placeholder: "Enter last name",
        error: { required: true }
    },
    {
        label: "Phone",
        name: "phoneno",
        placeholder: "Eg: 9876543210",
        type: "tel",
        error: { name: "phone number", required: true, minlength: 10, maxlength: 10 }
    },
    {
        label: "Email",
        name: "email",
        placeholder: "Eg:user@email.com",
        error: { type: "email", required: true }
    },
    {
        label: "Address",
        name: "address",
        type: "textarea",
        placeholder: "Enter user address",
        error: { required: true, minlength: 10 }
    }
]
export default function Profile() {


    const { data, inputProps, isError, setData, setTouched } = useForm({ schema })

    const onSubmit = async () => {

        if (isError()) {
            setTouched(true)
            return
        }
        try {

        } catch (error) {
            alert(error.message)
        }
    }

    const labels = [
        "First Name",
        "Last Name",
        "Mobile",
        "Email",
        "Address"
    ];


    return (
        <Stack direction={"row"} justifyContent={"center"} alignItems={"center"}>
            <Paper elevation={4} sx={{ p: 4, m: 2, width: "100%", maxWidth: 600 }}>

                My Profile
                <br />
                <br />
                <Avatar variant="rounded" sx={{ width: 56, height: 56 }} />
                {/* <Stack spacing={2}>
                    {schema.map(d => <Input {...inputProps(d)} />)}

                    <Stack flexDirection={"row"} justifyContent={"space-between"}>
                        <Button color="error">Back</Button>
                        <Button onClick={onSubmit} variant='contained'>Next</Button>
                    </Stack>
                </Stack> */}
                <br />
                <Stack>
                    {labels.map(d => <LabelValue label={d} />)}

                </Stack>
                <br />
                <Button variant="outlined">Edit <Edit /></Button>
            </Paper>
        </Stack>
    )
}

const LabelValue = ({ label, value }) => {
    return <div>
        <Typography fontWeight={500}>{label}</Typography>
        {value || "--"}
    </div>
}